<table class="exercises">
  <tr *ngFor="let exercise of exercises; let i = index;">
    <td *ngIf="!PUZZLE.includes(exercise.type)" class="index">{{i + 1}})</td>
    <td class="question" *ngIf="exercise.type !== MAGIC_BOX && !PUZZLE.includes(exercise.type)">
        <ng-katex *ngIf="isKatexFormat(exercise)" class="katex" [equation]="exercise.text"></ng-katex>
        <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)"  class="text"
                            [class.block]="exercise.type === TASK || exercise.type === LOGIC"
                            [paragraph]="exercise.text | exerciseFormat:'text'">
        </ng-katex-paragraph>
      <div
        class="answer"
        [class.task-answer]="exercise.type === TASK"
        *ngIf="isCorrect(exercise, studentAnswers[i]); else wrongAnswer;">
        {{exercise.answers[0].shortAnswer}}
      </div>
      <ng-template #wrongAnswer>
        <div class="answer">
          <span class="wrong">{{studentAnswers[i].shortAnswer}}</span>
          <span class="true">{{ exercise.answers[0].shortAnswer }}</span>
        </div>
      </ng-template>
    </td>
    <td class="question" *ngIf="PUZZLE.includes(exercise.type)">
      <app-exercise-puzzle
        [exercise]="exercise"
        [index]="i"
        [viewType]="'result_modal'"
        [currentAnswer]="studentAnswers[i].shortAnswer"
        [studentAnswer]="studentAnswers[i]">
      </app-exercise-puzzle>
    </td>
    <td
      class="question magic-box"
      *ngIf="exercise.type === MAGIC_BOX">
      <table class="magic-box__table">
        <tr *ngFor="let row of parseString(studentAnswers[i].shortAnswer); let i = index;">
          <td class="answer" *ngFor="let col of row; let j = index;">
            <span *ngIf="parseString(exercise.answers[0].shortAnswer)[i][j] === col">
              {{ col }}
            </span>
            <span *ngIf="parseString(exercise.answers[0].shortAnswer)[i][j] !== col">
              <span class="wrong">{{col}}</span>
              <span class="true">{{ parseString(exercise.answers[0].shortAnswer)[i][j] }}</span>
            </span>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
